import Tabs, { TabsProps } from 'antd/lib/tabs';
import { add, sub } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { CAISO_TZ } from 'src/domain/caiso';

type DayValue = 'yesterday' | 'today' | 'tomorrow';

interface IMarketAwardsDaysSelectorProps {
    value: DayValue;
    counters: {
        yesterday: number;
        today: number;
        tomorrow: number;
    };
    onChange: (val: DayValue) => void;
}

export const MarketAwardsDaysSelector = ({ onChange, value, counters }: IMarketAwardsDaysSelectorProps) => {
    const today = new Date();
    const yesterdayFormatted = formatInTimeZone(sub(today, { days: 1 }), CAISO_TZ, 'MM/dd/yy');
    const todayFormatted = formatInTimeZone(today, CAISO_TZ, 'MM/dd/yy');
    const tomorrowFormatted = formatInTimeZone(add(today, { days: 1 }), CAISO_TZ, 'MM/dd/yy');

    const yesterdayCounter = counters.yesterday > 0 ? ` (${counters.yesterday})` : '';
    const todayCounter = counters.today > 0 ? ` (${counters.today})` : '';
    const tomorrowCounter = counters.tomorrow > 0 ? ` (${counters.tomorrow})` : '';

    const onDayChange = (key: string) => {
        const newValue = key as DayValue;
        onChange(newValue);
    };

    const items: TabsProps['items'] = [
        {
            key: 'yesterday',
            label: `Yesterday ${yesterdayFormatted} ${yesterdayCounter}`,
        },
        {
            key: 'today',
            label: `Today ${todayFormatted} ${todayCounter}`,
        },
        {
            key: 'tomorrow',
            label: `Tomorrow ${tomorrowFormatted} ${tomorrowCounter}`,
        },
    ];
    return <Tabs defaultActiveKey={value} items={items} onChange={onDayChange} />;
};
